import _ from "lodash";
import {
  CURRICULUM_TYPE_DP,
  PYP_SUBJECT_SPECIFIC,
} from "Constants/stringConstants";
import {
  FILTER_NAME_GRADES,
  FILTER_NAME_SUBJECTS,
} from "Course/Constants/StringConstants";
import { unitTypeLabels } from "UnitPlans/modules/UnitPlanModule";
import ACLStore from "lib/aclStore";
import { getAttachmentUrlFromFieldValue, getYearDurationFormat } from "Utils";
import { getFormattedUserName } from "Utils/GetFormattedUserName";

const feedListColumns = [
  {
    label: "",
    id: "radioButton",
    type: "CUSTOM",
    hideTooltip: true,
    style: { width: "40px" },
  },
  {
    label: "unitPlan:unit_name",
    id: "unitName",
    type: "CUSTOM",
    hideTooltip: true,
  },
  {
    label: "common:unit_type_label",
    id: "unitType",
    type: "TEXTCOLUMN",
    hideTooltip: true,
    style: { width: "180px" },
    curriculumTypeToExclude: [CURRICULUM_TYPE_DP],
  },
  {
    label: "common:subject_plural",
    id: "subjects",
    type: "ARRAYCOLUMNWITHOVER",
    hideTooltip: true,
    moreStyle: { paddingLeft: "4px" },
  },
  {
    label: "common:grades",
    id: "grades",
    type: "ARRAYCOLUMNWITHOVER",
    hideTooltip: true,
    moreStyle: { paddingLeft: "4px" },
  },
  {
    label: "common:academic_year",
    id: "academicYear",
    type: "ARRAYCOLUMNWITHOVER",
    hideTooltip: true,
    moreStyle: { paddingLeft: "4px" },
    modalTypeToExclude: ["ADD_FROM_TODDLE_LIBRARY"],
  },
  {
    label: "common:created_by",
    id: "createdBy",
    type: "TEXTCOLUMN",
    hideTooltip: true,
    modalTypeToExclude: ["ADD_FROM_TODDLE_LIBRARY"],
  },
];

const getFeedlistColumns = ({ modalType, t, curriculumType }) => {
  return _.reduce(
    feedListColumns,
    (result, column) => {
      if (
        !_.includes(_.get(column, "modalTypeToExclude", []), modalType) &&
        !_.includes(
          _.get(column, "curriculumTypeToExclude", []),
          curriculumType
        )
      )
        result.push({
          ...column,
          label: !_.isEmpty(column.label) ? t(column.label) : "",
        });
      return result;
    },
    []
  );
};

export const getFeedlistColumnsMemoized = _.memoize(
  getFeedlistColumns,
  params => JSON.stringify(params)
);

const getUnitPlanFeedData = ({ unitPlans, t, gradeList }) => {
  return _.map(unitPlans, unitPlan => {
    const { node } = unitPlan;
    const image = getAttachmentUrlFromFieldValue({
      fieldValue: _.get(node, "image", {}),
    });
    return {
      id: _.get(node, "id", ""),
      radioButton: _.get(node, "id", ""),
      unitName: {
        id: _.get(node, "id", ""),
        title: _.get(node, "title.value", ""),
        image,
      },
      unitType: t(
        _.get(
          unitTypeLabels,
          _.get(node, "unitType.value", PYP_SUBJECT_SPECIFIC),
          ""
        )
      ),
      subjects: _.map(
        _.get(node, "subjects.resolvedMinimalTree.subjects", []),
        subject => subject.name
      ),
      grades: _.reduce(
        gradeList,
        (result, grade) => {
          if (_.includes(_.get(node, "grades", []), grade.value))
            result.push(grade.label);
          return result;
        },
        []
      ),
      academicYear: _.map(_.get(node, "academicYears", []), academicYear => {
        return getYearDurationFormat({
          startDate: academicYear.startDate,
          endDate: academicYear.endDate,
        });
      }),
      createdBy: _.get(node, "owner.firstName")
        ? getFormattedUserName({ user: _.get(node, "owner") })
        : getFormattedUserName({ user: _.get(node, "createdBy") }),
    };
  });
};

export const getUnitPlanFeedDataMemoized = _.memoize(
  getUnitPlanFeedData,
  params => JSON.stringify(params)
);

const getFilterInfo = ({
  gradeList,
  subjectsList,
  currentCurriculumType,
  unitTypeOptions,
  courseList,
  filterList,
}) => {
  let filters = [
    {
      id: "GRADE",
      name: FILTER_NAME_GRADES,
      options: gradeList,
      label: "common:grade",
      showSearchBar: true,
      showAllOption: true,
      noOptionLabel: "common:select",
      type: "CHECKLIST_DROPDOWN",
    },
    {
      id: "SUBJECT",
      name: FILTER_NAME_SUBJECTS,
      options: subjectsList,
      label: "common:subject",
      showSearchBar: true,
      showAllOption: true,
      noOptionLabel: "common:select",
      type: "CHECKLIST_DROPDOWN",
    },
    {
      id: "UNIT_TYPE",
      name: "unitType",
      options: unitTypeOptions,
      label: "common:unit_type_label",
      showAllOption: true,
      noOptionLabel: "common:select",
      type: "CHECKLIST_DROPDOWN",
      curriculumToExclude: [CURRICULUM_TYPE_DP],
    },
    {
      id: "COURSE",
      name: "courses",
      options: courseList,
      label: "common:course_plural",
      showAllOption: true,
      noOptionLabel: "common:select",
      type: "CHECKLIST_DROPDOWN",
    },
  ];
  filters = _.filter(filters, filter => _.includes(filterList, filter.id));
  return _.filter(
    filters,
    filter =>
      !_.includes(
        _.get(filter, "curriculumToExclude", []),
        currentCurriculumType
      ) && (_.get(filter, "perm", null) ? ACLStore.can(filter.perm) : true)
  );
};

export const getFilterInfoMemoized = _.memoize(getFilterInfo, params =>
  JSON.stringify(params)
);
